import axios from "axios";
import { encryptRequest, decryptResponse } from "../utils/crypto";
const secureApi = axios.create({
  baseURL:`${process.env.REACT_APP_API_URL_NAME}`,
  headers: {
    "Content-Type": "application/json",
  },
});
// REQUEST INTERCEPTOR
secureApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data) {
      config.data = encryptRequest(config.data);
    }
    return config;
  },
  (error) => Promise.reject(error)
);
// RESPONSE INTERCEPTOR
secureApi.interceptors.response.use(
  (response) => {
    console.log("response before decrypt:", response.data);

    response.data = decryptResponse(response.data);

    console.log("response after decrypt:", response.data);

    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear authentication data
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Clear session storage if used
      sessionStorage.clear();

      // Prevent redirect loop
      if (
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/"
      ) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);
export default secureApi;